import { reactive, ref, watch } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-549a679b"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "ps-title"
};
import { OK, reportEvent } from '@/common';
import { message } from 'ant-design-vue';
import { saveAccountInfo } from '@/api/payManage/accountManage';
export default /*#__PURE__*/_defineComponent({
  __name: 'NewAccountModal',
  props: {
    modalVisible: {
      type: Boolean
    },
    editItem: null
  },
  emits: ['update:modalVisible', 'update:editItem', 'refreshList'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const divideList2 = [{
      label: '85%',
      value: '0.85'
    }, {
      label: '70%',
      value: '0.7'
    }]; // 分成比例
    const rules = {
      accountName: [{
        required: true,
        message: '请输入账号',
        trigger: 'blur'
      }],
      country: [{
        required: true,
        message: '请输入国家',
        trigger: 'blur'
      }],
      channelType: [{
        required: true,
        message: '请输入类型',
        trigger: 'blur'
      }],
      coefficient: [{
        required: true,
        message: '请选择分成比例',
        trigger: 'blur'
      }]
    };
    const orderForm = reactive({
      accountName: '',
      country: '',
      channelType: '',
      subscribeUrl: '',
      vendorNum: '',
      coefficient: '0.85'
    });
    const orderRef = ref(null);
    const closeModal = () => {
      var _orderRef$value;
      Object.assign(orderForm, initForm());
      (_orderRef$value = orderRef.value) === null || _orderRef$value === void 0 || _orderRef$value.clearValidate();
      emit('update:modalVisible', false);
      emit('update:editItem', {});
    };
    const initForm = () => {
      return {
        accountName: '',
        country: '',
        channelType: '',
        subscribeUrl: '',
        vendorNum: ''
      };
    };
    const submitModal = () => {
      var _orderRef$value2;
      (_orderRef$value2 = orderRef.value) === null || _orderRef$value2 === void 0 || _orderRef$value2.validate().then(async () => {
        let params = {
          accountId: orderForm.accountId,
          coefficient: orderForm.coefficient,
          subscribeUrl: orderForm.subscribeUrl,
          vendorNum: orderForm.vendorNum
        };
        try {
          const {
            code,
            msg
          } = await saveAccountInfo(params);
          if (code === OK) {
            message.success(msg);
            closeModal();
            emit('refreshList');
            reportEvent({
              eventName: 'element_use',
              properties: {
                ui_name: '账号管理',
                element_name: '编辑'
              }
            });
          }
        } catch (error) {}
      }).catch(err => {});
    };
    watch(() => props.editItem, n => {
      if (typeof n === 'object') {
        Object.assign(orderForm, n);
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        title: "账号信息",
        onCancel: closeModal,
        onOk: submitModal,
        centered: "",
        open: __props.modalVisible,
        width: "523px",
        "ok-text": "提交"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form, {
          name: "order",
          model: orderForm,
          ref_key: "orderRef",
          ref: orderRef,
          rules: rules,
          "label-col": {
            span: 4
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_a_form_item, {
            label: "账号：",
            name: "accountName"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: orderForm.accountName,
              "onUpdate:value": _cache[0] || (_cache[0] = $event => orderForm.accountName = $event),
              disabled: "",
              placeholder: "请输入账号"
            }, null, 8, ["value"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "国家：",
            name: "country"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: orderForm.country,
              "onUpdate:value": _cache[1] || (_cache[1] = $event => orderForm.country = $event),
              disabled: "",
              placeholder: "请完善项目管理系统账号信息"
            }, null, 8, ["value"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "类型：",
            name: "channelType"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: orderForm.channelType,
              "onUpdate:value": _cache[2] || (_cache[2] = $event => orderForm.channelType = $event),
              disabled: "",
              placeholder: "请输入类型"
            }, null, 8, ["value"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "分成比例：",
            name: "coefficient"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_select, {
              value: orderForm.coefficient,
              "onUpdate:value": _cache[3] || (_cache[3] = $event => orderForm.coefficient = $event),
              options: divideList2
            }, null, 8, ["value"]), orderForm.channelType === '谷歌' ? (_openBlock(), _createElementBlock("div", _hoisted_1, " 谷歌分成比例将在每年UTC时间1月1日0点重置为85% ")) : _createCommentVNode("", true)]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "订阅回调：",
            name: "subscribeUrl"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: orderForm.subscribeUrl,
              "onUpdate:value": _cache[4] || (_cache[4] = $event => orderForm.subscribeUrl = $event),
              valueModifiers: {
                trim: true
              },
              placeholder: "http://"
            }, null, 8, ["value"])]),
            _: 1
          }), __props.editItem.channelType == '苹果' ? (_openBlock(), _createBlock(_component_a_form_item, {
            key: 0,
            label: "供应商编号：",
            name: "vendorNum"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: orderForm.vendorNum,
              "onUpdate:value": _cache[5] || (_cache[5] = $event => orderForm.vendorNum = $event),
              valueModifiers: {
                trim: true
              },
              placeholder: "请输入供应商编号"
            }, null, 8, ["value"])]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["open"]);
    };
  }
});